import React from "react";
import classes from "./Footer.scss";
import { Button } from "@toddle-edu/ds-web";

const Footer = props => {
  const {
    t,
    onClickCancel,
    onClickAdd,
    isAddButtonDisabled,
    selectedEvidenceCount,
    addButtonLabel,
  } = props;
  const labelContainerClass = "text-label";

  return (
    <div className={classes.container}>
      <div className={labelContainerClass}>
        {t("snp:selected_evidence_count", {
          count: selectedEvidenceCount,
        })}
      </div>
      <div className={classes.btnCon}>
        <div className={classes.cancelButton}>
          <Button
            variant="neutral"
            type="outlined"
            onClick={onClickCancel}
            dsVersion="2.0"
          >
            {t(`common:cancel`)}
          </Button>
        </div>
        <Button
          variant={"progressive"}
          disabled={isAddButtonDisabled}
          onClick={onClickAdd}
          dsVersion="2.0"
          shortcut={{ code: "Enter", shiftKey: true }}
        >
          {addButtonLabel ? addButtonLabel : t(`common:add`)}
        </Button>
      </div>
    </div>
  );
};

export default Footer;
